'use client';

import { useTranslations } from 'next-intl';
import type { PlayerStanding } from '@/draw/types';

interface StandingsTableProps {
  standings: PlayerStanding[];
  highlightPlayerId?: string;
}

const GOLD = '#F5A623';

export function StandingsTable({ standings, highlightPlayerId }: StandingsTableProps) {
  const t = useTranslations('Celebration');

  return (
    <div>
      {standings.map((player, i) => {
        const isHighlighted = player.playerId === highlightPlayerId;
        const isFirst = i === 0;

        return (
          <div
            key={player.playerId}
            className="flex items-center border-b border-[#1B2D4F]/[0.06] py-3.5 lg:py-4"
            style={
              isHighlighted
                ? { background: `linear-gradient(90deg, ${GOLD}15, transparent)` }
                : undefined
            }
          >
            {/* Rank number — large Anton */}
            <div
              className="w-10 flex-shrink-0 text-center text-[28px] leading-none lg:w-12 lg:text-[32px]"
              style={{
                fontFamily: 'var(--font-anton)',
                color: isFirst ? GOLD : '#1B2D4F20',
              }}
            >
              {player.position}
            </div>

            {/* Player info */}
            <div className="ml-3 min-w-0 flex-1">
              <div
                className="truncate text-[15px] text-[#1B2D4F]"
                style={{ fontWeight: isFirst || isHighlighted ? 700 : 500 }}
              >
                {player.playerName}
                {isHighlighted && (
                  <span className="ml-1.5 text-[10px] tracking-wider text-[#8B95A5] uppercase">
                    &larr; you
                  </span>
                )}
              </div>
              <div className="text-[12px] text-[#8B95A5]">
                {t('gamesRecord', { won: player.gamesWon, lost: player.gamesLost })} &middot;{' '}
                {player.points} pts
              </div>
            </div>

            {/* W-L record */}
            <div
              className="flex-shrink-0 text-[16px] lg:text-[18px]"
              style={{
                fontFamily: 'var(--font-anton)',
                color: '#1B2D4F',
              }}
            >
              {player.wins}–{player.losses}
            </div>
          </div>
        );
      })}
    </div>
  );
}
